const { useCallback } = require('react');
const { useDispatch, useSelector } = require('react-redux');
const { useLocation, useNavigate } = require('react-router-dom');
const distributionActions = require('distributionActions');
const { publishFieldFocus } = require('../fieldFocusBus');
const { getSearchNavigationPlan } = require('./globalSearchHelpers');

// A distribution is never selected on its own — the rest of the app assumes a
// farming unit is selected too, so fall back to its first one. Mirrors what
// DistributionsDropdown does on selection.
const getFirstFarmingUnitId = (distribution) =>
  Object.keys(distribution?.farming_units ?? {})[0];

const resolveTarget = (entry, allDistributions) => ({
  distributionId: entry.distributionId,
  farmingUnitId:
    entry.farmingUnitId ??
    getFirstFarmingUnitId(allDistributions?.[entry.distributionId]),
  fieldId: entry.fieldId ?? null,
});

/**
 * Returns a callback that selects the entities behind a search result and
 * moves the user to the screen that shows them — or leaves them where they
 * are, when the current screen already can (see getSearchNavigationPlan).
 */
const useGlobalSearchNavigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const allDistributions = useSelector(
    (state) => state.distribution_data?.distributions?.distributions,
  );

  return useCallback(
    (entry) => {
      const target = resolveTarget(entry, allDistributions);
      dispatch(
        distributionActions.selected_entities_by_id(
          target.distributionId,
          target.farmingUnitId,
          target.fieldId,
        ),
      );

      const plan = getSearchNavigationPlan(entry, location.pathname);
      if (plan.focusField) {
        // The Farm View holds its selection and its trailing tab in component
        // state, so the Redux selection above is not enough on its own.
        publishFieldFocus(plan.focusField);
      }
      if (plan.path) {
        navigate(plan.path);
      }
    },
    [allDistributions, dispatch, location.pathname, navigate],
  );
};

module.exports = useGlobalSearchNavigation;
